import { useState } from 'react'

interface IConfigProps {
  sider: boolean
}

const getLocalSider = () => {
  const sider = localStorage.getItem('aisider')

  if (sider === 'false') {
    return false
  }

  return true
}

const setLocalSider = (sider: boolean) => {
  localStorage.setItem('aisider', String(sider))
}

const useConfigModel = () => {
  const [config, setConfig] = useState<IConfigProps>({
    sider: getLocalSider(),
  } as IConfigProps)

  const handleConfig = (curCfg: Partial<IConfigProps>) => {
    setConfig({
      ...config,
      ...curCfg,
    })

    if (process.env.NODE_ENV === 'development') {
      console.log('[configModel] handleConfig:', curCfg)
    }
    // 缓存数据
    if (curCfg.sider !== undefined) {
      setLocalSider(curCfg.sider)
    }
  }

  const initConfig = () => {
    const sider = getLocalSider()
    handleConfig({
      sider,
    })
  }

  return {
    config,
    handleConfig,
    initConfig,
  }
}

export default useConfigModel
